<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <h2>网站基本信息</h2>
        <a-form-model
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item has-feedback label="主标题">
            <a-input v-model="form.title" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="副标题">
            <a-input v-model="form.subtitle" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="网站关键词">
            <a-input v-model="form.keywords" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="网站描述">
            <a-input
              v-model="form.description"
              type="text"
              autocomplete="off"
            />
          </a-form-model-item>
          <a-form-model-item has-feedback label="备案号">
            <a-input v-model="form.icp" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="网站地址">
            <a-input v-model="form.url" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="百度统计URL">
            <a-input v-model="form.baidu" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="setInfo(form)">保存修改</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: {
        title: "",
        subtitle: "",
        keywords: "",
        description: "",
        icp: "",
        url: "",
        baidu: ""
      }
    };
  },
  created() {},
  mounted() {
    this.getInfo({ type: "seo" });
  },
  methods: {
    getInfo: function(_obj) {
      console.log(_obj);
      SETTING_query(_obj)
        .then(response => {
          this.form = response.res;
        })
        .catch(() => {});
    },
    setInfo: function(_obj) {
      SETTING_update({
        type: "seo",
        info: _obj
      })
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .btn-list {
    margin-top: 30px;
  }
}
</style>
